import React from "react";
import ReorderProcurementView from "../ReorderProcurementView";

// Reorder — lapsing-kit demand (A confident + v*B speculative) only, no +1 strip
// buffer. A structurally different, prototype-matched table shape from Overall/New —
// see ReorderProcurementView.jsx.
function ProcurementReorderPage() {
    return <ReorderProcurementView />;
}

export default ProcurementReorderPage;
